
export enum QuestionCategory {
  POLITICS = '政治理论',
  COMMON_SENSE = '常识判断',
  LANGUAGE = '言语理解与表达',
  QUANTITY = '数量关系',
  LOGIC = '判断推理',
  DATA_ANALYSIS = '资料分析'
}

export interface User {
  id: string;
  username: string;
  password?: string;
  nickname: string;
  avatar: string;
  externalToken?: string; 
}

export interface Question {
  id: string;
  createdAt: number;
  deletedAt?: number; 
  materials: string[];
  materialText?: string;
  stem: string;
  options: string[];
  correctAnswer: number;
  userAnswer?: number;
  accuracy: number; 
  category: string;     
  subCategory?: string; 
  tags?: string[];      
  notesImage?: string; 
  noteText?: string;   
  analysis?: string; 
  lastPracticedAt?: number;
  mistakeCount: number;
  correctCount?: number; 
  isMastered?: boolean;
  
  // Relations
  methodIds?: string[];     
  knowledgeIds?: string[];  

  // Spaced Repetition (Phase 3)
  reviewStage?: number;     // 0=New, 1=1d, 2=3d, 3=7d, 4=15d, 5=30d, 6=Mastered/90d
  nextReviewAt?: number;    // Timestamp for next review
}

export interface SessionDetail {
    questionId: string;
    userAnswer: number; 
    isCorrect: boolean;
    duration: number; 
}

export interface PracticeSession {
  id: string;
  date: number;
  questionIds: string[];
  score: number;
  totalDuration: number;
  details: SessionDetail[];
}

export interface IdiomData {
  word: string;
  meaning: string;
  usage: string;
  example: string;
}

export interface KnowledgeEntity {
  id: string;
  title?: string; 
  content: string; 
  type: 'IDIOM' | 'COMMON_SENSE' | 'CURRENT_AFFAIRS'; 
  tags?: string[]; 
  createdAt: number;
  idiomData?: IdiomData; 
}

export interface MethodEntity {
  id: string;
  userId: string;
  // Hierarchy
  category?: string;     
  subCategory?: string;  
  tag?: string;          
  
  title: string;       
  content: string;      
  createdAt: number;
  updatedAt: number;
}
